export { generateReplacementStringFromObj } from './_helpers/replacementString';
